import { call, put, takeLatest } from 'redux-saga/effects';
import { ReportMap } from 'types';
import { reportsLoadSuccess, reportsLoadFailure } from 'actions/reportActions';
import { handleErrorSaga } from 'sagas/app/handleError';
import { getReports } from 'api/reports';


export function* loadReportsRequestWatcher() {
    yield takeLatest('REPORTS_LOAD_REQUEST', loadReportsSaga);
}

export function* loadReportsSaga() {
    let reports: ReportMap;
    try {
        reports = yield call(getReports);
    }
    catch (err) {
        yield call(handleErrorSaga, err, reportsLoadFailure);
        return;
    }
    yield put(reportsLoadSuccess(reports));
}



// WEBPACK FOOTER //
// ./src/sagas/reports/loadReportsSaga.ts